<template>
  <div class="mt-4">
    <v-row>
      <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
      <v-col cols="12" xs="12" sm="6" md="4">
        <v-card class="pa-3">
          <div class="subtitle-1 mb-2">
            {{ $t("periodSummary") }}
            <v-icon
              class="float-right mr-3 d-print-none"
              @click="$copy(resumePrint)"
            >
              mdi-content-copy
            </v-icon>
            <div class="caption">
              <span v-once>
                {{ monthAndYear }}
              </span>
            </div>
          </div>

          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, key) in resume" :key="key">
                  <td class="caption">
                    {{ header(key) }}
                  </td>
                  <td
                    class="text-right"
                    :class="colorClass(item.valueWithoutFormat, key)"
                  >
                    {{ item.value }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["resume", "resumePrint"],

  computed: {
    monthAndYear() {
      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const date = new Date(year, month - 1, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      });

      return date.charAt(0).toUpperCase() + date.slice(1);
    },
  },

  methods: {
    header(key) {
      const myKeysTranslated = {
        affiliates_count: this.$t("numberOfAffiliates"),
        value: this.$t("payments.eligibleValue"),
        eligible: this.$t("payments.eligiblePlural"),
        not_eligible: this.$t("payments.notEligiblePlural"),
        historyValue: this.$t("commissionValue"),
        valueAll: this.$t("payments.valueAll"),
        gross_value: this.$t("revenues"),
        prize_value: this.$t("awards"),
        ggr_value: "GGR",
        ngr_value: "NGR",
        fee_value: this.$t("feeValue"),
      };

      return myKeysTranslated[key] || null;
    },
    colorClass(value, key) {
      const number = Number(value);

      if (["affiliates_count", "eligible", "not_eligible"].includes(key)) {
        return "";
      }

      if (
        [
          "fee_value",
          "value",
          "valueAll",
          "prize_value",
          "historyValue",
        ].includes(key)
      ) {
        return number === 0 ? "grey--text" : "red--text";
      }

      if (number === 0) {
        return "grey--text";
      } else if (number > 0) {
        return "green--text";
      } else {
        return "red--text";
      }
    },
  },
};
</script>
